import { useEffect } from "react";
import { useAnnounce } from "./use-announcer";

const SITE_NAME = "PlayNook Questly";

/**
 * Tracks whether a title has already been applied in this page load, so the
 * cold load isn't announced — the browser already reads the document title then.
 */
let hasAppliedTitle = false;

/**
 * Sets the document title and announces the new page on navigation.
 *
 * The app uses hash history, so a route change updates neither the title nor
 * the focus by itself; without this a screen-reader user gets no signal that
 * navigation happened at all.
 */
export function usePageTitle(title: string | null | undefined) {
  const announce = useAnnounce();

  useEffect(() => {
    if (!title) return;

    const fullTitle = `${title} · ${SITE_NAME}`;
    // Idempotent, which also makes StrictMode's double-invoked effect a no-op.
    if (document.title === fullTitle) return;

    document.title = fullTitle;

    if (hasAppliedTitle) {
      announce(title, { channel: "route" });
    }
    hasAppliedTitle = true;
  }, [title, announce]);
}
